import { useTranslations } from 'next-intl'
import Head from 'next/head'

import { FillerModule } from '@/components/FillerModule'
import { PageMetaTags } from '@/components/MetaTags'
import { Page } from '@/components/Page'
import { GameSelector } from '@/features/landing/GameSelector'
import Hero from '@/features/landing/Hero'
import { OurGames } from '@/features/storefronts/landing/OurGames'
import { StoreCards } from '@/features/storefronts/landing/StoreCard'

import { LinkButton } from '../components/buttons/Button'
import { wrapGetServerSideProps, setPublicPageCacheControl } from '../ssr/wrapper'

import NeedSomeHelp from 'assets/images/characters/need-some-help.png'

import styles from './landingpage.module.scss'

export default function Home({ useNewLanding }: { useNewLanding: boolean }) {
  const t = useTranslations()
  return (
    <Page>
      <PageMetaTags title={t('sitename')} description={t('home_description')} />
      <Head>
        <title>{t('sitename')}</title>
      </Head>
      {useNewLanding ? (
        <>
          <div className={styles.Sections}>
            <StoreCards />
            <OurGames />
          </div>
        </>
      ) : (
        <>
          <Hero />
          <GameSelector />
          <FillerModule
            className={styles.BottomFAQ}
            imageClassName={styles.BottomFAQImage}
            title={t('lan_need_some_help')}
            image={NeedSomeHelp}
            action={{ content: t('go_to_faq').toUpperCase(), link: '/help' }}
          >
            <span className={styles.Mobile}>
              {t.rich('lan_faq_body')}
              <LinkButton href="/help" type="Soft">
                {t('go_to_faq').toUpperCase()}
              </LinkButton>
            </span>
            <span className={styles.Desktop}>{t('lan_faq_body')}</span>
          </FillerModule>
        </>
      )}
    </Page>
  )
}

export const getServerSideProps = wrapGetServerSideProps(async (store, context, isRecognized, enabledStoreFronts) => {
  setPublicPageCacheControl(context, 30, 60)
  const useNewLanding = enabledStoreFronts.length > 0
  return {
    props: {
      useNewLanding,
    },
  }
}, 'storeInitSSR')
